<router-outlet></router-outlet>
<app-loading-page *ngIf="isLoading"></app-loading-page>
